import {graphql} from 'gatsby';

class Page {
  static fromWP(data) {
    const page = new Page();

    page.slug = data.slug;
    page.title = data.title;
    page.excerpt = data.excerpt.replace(/<[^>]*>/g, '');
    page.html = data.content;
    page.ogimage = null;
    page.thumbnail = null;
    page.uri = data.link;
    page.acf = data.acf;

    if (data.featured_media && data.featured_media.localFile) {
      const file = data.featured_media.localFile;
      if (file.childImageSharp) {
        page.ogimage = file.childImageSharp.og;
        page.thumbnail = {
          fluid: file.childImageSharp.fluid,
          alt: data.featured_media.media_details.image_meta.title,
        };
      }
    }

    return page;
  }

  getURL() {
    return `https://samiabomfim.com.br${this.uri}`;
  }
}

export const query = graphql`
fragment WPPage on wordpress__PAGE {
  slug
  title
  excerpt
  content
  link

  acf {
    pageTemplate: page_template
    channelId: channel_id
    formTitle: form_title
    heroBgColor: hero_bg_color
    heroLogo: hero_logo {
      source_url
    }
  }

  featured_media {
    localFile {
      childImageSharp {
        fluid(maxWidth: 960) {
          ...GatsbyImageSharpFluid
        }

        og: fixed(width: 1200, height: 630) {
          src
          width
          height
        }
      }
    }

    media_details {
      image_meta {
        title
      }
    }
  }
}
`;

export default Page;
